import { render, staticRenderFns } from "./App2.vue?vue&type=template&id=cfa23556&scoped=true&"
import script from "./App2.vue?vue&type=script&lang=js&"
export * from "./App2.vue?vue&type=script&lang=js&"
import style0 from "./App2.vue?vue&type=style&index=0&id=cfa23556&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa23556",
  null
  
)

export default component.exports